import { Component, input } from '@angular/core';

/**
 * Simple component to display message timestamps.
 * Styles are inherited from the parent chat-message component to support
 * different styling based on message role (user vs assistant).
 */
@Component({
  selector: 'app-message-timestamp',
  standalone: true,
  template: `
    @if (timestamp()) {
      <div class="message-timestamp">{{ timestamp() }}</div>
    }
  `,
})
export class MessageTimestampComponent {
  public readonly timestamp = input<string | null>(null);
}
